import {permissions} from "@/enums/permissions.enum";

export default [
    {
        title: 'dashboard',
        icon: 'home-icon',
        tagVariant: 'light-warning',
        route: 'dashboard',
        permissions: [],
    },
    {
        title: 'orders',
        icon: 'orders-icon',
        tagVariant: 'light-warning',
        route: 'orders',
        permissions: [permissions.readOrders]
    },
    {
        title: 'chat',
        icon: 'nav-chat-icon',
        tagVariant: 'light-warning',
        route: 'chat',
        permissions: [permissions.chat]
    },
    {
        title: 'ads',
        icon: 'nav-ads-icon',
        tagVariant: 'light-warning',
        route: 'ads',
        permissions: [permissions.readAds]
    },
    {
        title: 'users.title',
        icon: 'nav-users-icon',

        tagVariant: 'light-warning',
        route: 'users',

        permissions: [permissions.readClientsInfo, permissions.readClientsOrders, permissions.readCompaniesInfo, permissions.readCompaniesFinancials, permissions.readCompaniesProducts, permissions.readCompaniesCategories, permissions.readCompaniesOrders, permissions.readCompaniesReviews, permissions.readDriversInfo, permissions.readDriversFinancials, permissions.readDriversOrders, permissions.readDriversReviews],

        children: [
            {
                title: 'users.clients',
                icon: 'nav-other-icon',
                tagVariant: 'light-warning',
                route: 'users-clients',
                permissions: [permissions.readClientsInfo]
            },
            {
                title: 'users.vendors',
                icon: 'nav-other-icon',
                tagVariant: 'light-warning',
                route: 'users-vendors',
                permissions: [permissions.readCompaniesInfo, permissions.readCompaniesFinancials, permissions.readCompaniesProducts, permissions.readCompaniesCategories, permissions.readCompaniesOrders, permissions.readCompaniesReviews],
            },
            {
                title: 'users.drivers',
                icon: 'nav-other-icon',
                tagVariant: 'light-warning',
                route: 'users-drivers',
                permissions: [permissions.readDriversInfo, permissions.readDriversFinancials, permissions.readDriversOrders, permissions.readDriversReviews],
            },
        ]
    },


    {

        title: 'financial.title',
        icon: 'money-icon',
        tagVariant: 'light-warning',
        route: 'financial-all',
        permissions: [permissions.readFinancials],

    },
    {

        title: 'reports',
        icon: 'nav-reports-icon',
        tagVariant: 'light-warning',
        route: 'reports',
        permissions: [permissions.readFinancials],//todo:: change permission

    },

    {
        title: 'discounts',
        icon: 'coupons-icon',
        tagVariant: 'light-warning',


        permissions: [permissions.readDiscounts],
        children: [
            {
                title: 'discounts-platform',
                icon: 'nav-other-icon',
                tagVariant: 'light-warning',
                route: 'discounts',
                permissions: [permissions.readDiscounts],
            },
            {
                title: 'discounts-vendors',
                icon: 'nav-other-icon',
                tagVariant: 'light-warning',
                route: 'discounts-vendors',
                permissions: [permissions.readDiscounts],
            }
        ]
    },


    {
        title: 'reviews',
        icon: 'star-icon',
        tagVariant: 'light-warning',
        route: 'reviews',
        permissions: [permissions.readReviews],
    },
    {
        title: 'settings',
        icon: 'setting-icon',
        tagVariant: 'light-warning',
        route: 'settings',
        permissions: [],
    },
];
